import request from './service'
import request2 from './service2'
import store from './store/store'
// import axios from 'axios'
import config from '../static/config/config'

export const separateThousand = (num) => {
  if (!num || num === '0') {
    return '0.00'
  } else {
    num = String(num)
    let decimal = num.split('.')[1]
    if (decimal && decimal.length === 1) {
      decimal += '0'
    } else if (decimal && decimal.length > 2) {
      decimal = decimal.substring(0, 2)
    }
    const integerInitial = num.split('.')[0]
    const reverseArr = integerInitial.split('').reverse()
    const integerReverseArr = []
    reverseArr.forEach((item, index) => {
      if (index && !(index % 3)) {
        integerReverseArr.push(',')
      }
      integerReverseArr.push(item)
    })
    const integer = integerReverseArr.reverse().join('')
    return integer + '.' + (decimal || '00')
  }
}

export const separateThousandInteger = (num) => {
  if (!num || num === '0') {
    return '0'
  } else {
    num = String(num)
    const integerInitial = num
    const reverseArr = integerInitial.split('').reverse()
    const integerReverseArr = []
    reverseArr.forEach((item, index) => {
      if (index && !(index % 3)) {
        integerReverseArr.push(',')
      }
      integerReverseArr.push(item)
    })
    const integer = integerReverseArr.reverse().join('')
    return integer
  }
}

export const fetchBalance = () => {
  const userInfo = JSON.parse(localStorage.getItem('userInfo'))
  if (userInfo) {
    request('post', '/innovation/account/getuserbalance', {
      userId: userInfo.UserId
    }, true).then(res => {
      console.log(res)
      store.commit('setBalance', res)
      if (res.Inactive === true) {
        console.log('getuserbalance: log out')

        localStorage.removeItem('userInfo')
        this.$router.go(0)
      }
    }).catch(err => {
      console.log(err)
    })
  }
}

/****
 * 检测是否手机浏览器访问
 * @returns {boolean}
 * 2021-10-23 LBL create
 */
export const isMobileAgent = () => {
  let isMobile = true
  try {
    isMobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  } catch (err) {
    console.log(err)
  }
  return isMobile
}

/****
 * 检查是否有新的APP版本待更新
 * 2021-07-26 CHP 创建
 * 2022-06-20 CHP 非核心业务走Service2
 */
export const checkApkVersion = () => {
  if (window.Android && !isIOS()) {
    const url = '/innovation/home/checkapkupdate'
    const data = {
      localApkVersion: localStorage.getItem('apkV') ? localStorage.getItem('apkV') : '1.0.0'
    }
    request2('post', url, data, true).then(res => {
      if (res.data.HasNewApkVersion === true) {
        store.commit('setHasNewApkVersion', true)
      }
      localStorage.setItem('newApkVersion', res.data.NewVersion)
    }).catch(err => {
      console.log(err)
    })
  }
}

/****
 * 根据日期值返回日期英文名
 * @param month
 * @returns {string}
 * 2021-07-09 C007 创建
 */
export const getDayName = function (day) {
  let name = ''
  switch (day) {
    case 1:
      name = '1st'
      break
    case 2:
      name = '2nd'
      break
    case 3:
      name = '3rd'
      break
    case 4:
      name = '4th'
      break
    case 5:
      name = '5th'
      break
    case 6:
      name = '6th'
      break
    case 7:
      name = '7th'
      break
    case 8:
      name = '8th'
      break
    case 9:
      name = '9th'
      break
    case 10:
      name = '10th'
      break
    case 11:
      name = '11th'
      break
    case 12:
      name = '12th'
      break
    case 13:
      name = '13th'
      break
    case 14:
      name = '14th'
      break
    case 15:
      name = '15th'
      break
    case 16:
      name = '16th'
      break
    case 17:
      name = '17th'
      break
    case 18:
      name = '18th'
      break
    case 19:
      name = '19th'
      break
    case 20:
      name = '20th'
      break
    case 21:
      name = '1st'
      break
    case 22:
      name = '22nd'
      break
    case 23:
      name = '23rd'
      break
    case 24:
      name = '24th'
      break
    case 25:
      name = '25th'
      break
    case 26:
      name = '26th'
      break
    case 27:
      name = '27th'
      break
    case 28:
      name = '28th'
      break
    case 29:
      name = '29th'
      break
    case 30:
      name = '30th'
      break
    case 31:
      name = '31st'
      break
  }
  return name
}

/****
 * 根据月份值返回月份英文名
 * @param month
 * @returns {string}
 * 2021-07-09 C007 创建
 */
export const getMonthName = function (month) {
  let name = ''
  switch (month) {
    case 1:
      name = 'January'
      break
    case 2:
      name = 'February'
      break
    case 3:
      name = 'March'
      break
    case 4:
      name = 'April'
      break
    case 5:
      name = 'May'
      break
    case 6:
      name = 'June'
      break
    case 7:
      name = 'July'
      break
    case 8:
      name = 'August'
      break
    case 9:
      name = 'September'
      break
    case 10:
      name = 'October'
      break
    case 11:
      name = 'November'
      break
    case 12:
      name = 'December'
      break
  }
  return name
}

/****
 * 根据时长获取时间字符串 00:00:00
 * @param timeSpan
 * 2021-07-18 C007 创建
 */
export const getTimeSpanString = function (timeSpan) {
  let secondsTempSpan = timeSpan / 1000
  let hours = secondsTempSpan / (60 * 60) // 小时
  secondsTempSpan = secondsTempSpan % (60 * 60)
  let minutes = secondsTempSpan / 60
  secondsTempSpan = secondsTempSpan % 60
  let seconds = secondsTempSpan
  let spanString = ''
  if (hours < 10) {
    spanString += '0' + parseInt(hours)
  } else {
    spanString += parseInt(hours)
  }
  if (minutes < 10) {
    spanString += ':0' + parseInt(minutes)
  } else {
    spanString += ':' + parseInt(minutes)
  }
  if (seconds < 10) {
    spanString += ':0' + parseInt(seconds)
  } else {
    spanString += ':' + parseInt(seconds)
  }
  return spanString
}

/****
 * 获取当前UTC时间
 * 2021-07-18 C007 创建
 */
export const getUTCNow = function () {
  let now = new Date()
  return new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(),
    now.getUTCHours(), now.getUTCMinutes(), now.getSeconds())
}

/***
 * 检查Banner显示条件是否满足
 * @param conditionType
 * 2022-03-30 CHP 创建
 */
export const checkBannerCondition = function (conditionType) {
  let show = false
  let userInfo = JSON.parse(localStorage.getItem('userInfo'))
  switch (conditionType) {
    case 'FirstDeposit':
      if (store.state.userFirstDeposit || !userInfo) {
        show = true
      }
      break
    case 'Callback':
      if (this.$store.state.callbackTimeSpan > 0 || !userInfo) {
        show = true
      }
      break
    default:
      show = true
  }
  return show
}

export const isIOS = function () {
  return [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod'
  ].includes(navigator.platform) ||
    (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
}

export const setCurrentModal = function (currentModalIndex) {
  let userInfo = JSON.parse(localStorage.getItem('userInfo'))
  let modals = store.state.modals
  store.commit('setCurrentModalIndex', currentModalIndex)
  modals = modals.map((item, itemIndex) => {
    // 判断上次显示时间是否超过24H，超过重置弹窗次数（三个弹窗都在此处重置）
    if ((new Date()).getTime() - item.updateDateSpan > 86400000 && itemIndex !== 0) { // itemIndex 7日签到充值部分不重置每日次数
      item.popupTimes = 0
    }
    // 判断是否符合七日礼包弹出条件
    let giftCollectInfo = store.state.giftCollectInfo
    if (currentModalIndex === 0 && itemIndex === 0) {
      if (!giftCollectInfo.isDeposited) {
        item.popupTimes = 0// 充值之后有一次弹出,充值之前置为0
        item.maxPopupTimes = 1
      }
      let showing = giftCollectInfo.hasGiftLeft && ((giftCollectInfo.mayCollectDeposit && item.popupTimes < item.maxPopupTimes) || giftCollectInfo.mayCollectFree)
      if (showing && userInfo) { // ytw 用户充值完成,为用户弹出签到活动页面一次
        if (giftCollectInfo.mayCollectDeposit) {
          item.popupTimes++
        }
        // item.updateDateSpan = new Date().getTime()
      } else if (!userInfo) { // 当没有用户登录，正常弹出七日签到礼包，不进行弹出数据记录
        return ({
          ...item,
          showing: true
        })
      }
      return ({
        ...item,
        showing: showing
      })
    }

    // 判断用户是否首充 弹出首充礼包
    if (itemIndex === 1 && currentModalIndex === 1) {
      let showing = store.state.userFirstDeposit

      if (showing) {
        item.popupTimes++
        item.updateDateSpan = new Date().getTime()
      }
      return ({
        ...item,
        showing: showing
      })
    }

    // 2023-03-27hp 判断用户是否是回归用户 弹出回归充值礼包
    if (itemIndex === 2 && currentModalIndex === 2) {
      let showing = store.state.callbackTimeSpan > (new Date()).getTime() &&
      !store.state.hideCallbackPop && item.popupTimes < item.maxPopupTimes
      if (showing) {
        item.popupTimes++
        item.updateDateSpan = new Date().getTime()
      }
      return ({
        ...item,
        showing: showing
      })
    }

    // 弹出常态化流水活动
    if (itemIndex === 3 && currentModalIndex === 3) {
      let showing = item.popupTimes < item.maxPopupTimes
      if (showing) {
        item.popupTimes++
        item.updateDateSpan = new Date().getTime()
      }
      return ({
        ...item,
        showing: showing
      })
    }

    // 空出一个弹窗保证两端代码同步
    // if (itemIndex === 4 && currentModalIndex === 4) {
    //   let showing = false
    //
    //   if (showing) {
    //     item.updateDateSpan = new Date().getTime()
    //   }
    //   return ({
    //     ...item,
    //     showing: showing
    //   })
    // }

    // Jili活动弹窗
    if ((itemIndex === 5 && currentModalIndex === 5) || (itemIndex === 9 && currentModalIndex === 9)) {
      let showing = item.popupTimes < item.maxPopupTimes

      if (showing) {
        item.popupTimes++
        item.updateDateSpan = new Date().getTime()
      }
      return ({
        ...item,
        showing: showing
      })
    }

    // vip体系
    if ((itemIndex === 10 && currentModalIndex === 10)) {
      let showing = item.popupTimes < item.maxPopupTimes

      if (showing) {
        item.popupTimes++
        item.updateDateSpan = new Date().getTime()
      }
      return ({
        ...item,
        showing: showing
      })
    }

    // 转盘充赠券弹窗
    if (itemIndex === 6 && currentModalIndex === 6) {
      let showing = item.popupTimes < item.maxPopupTimes

      if (showing) {
        item.popupTimes++
        item.updateDateSpan = new Date().getTime()
      }
      return ({
        ...item,
        showing: showing
      })
    }

    // 弹出转盘任务
    if (itemIndex === 7 && currentModalIndex === 7) {
      let showing = item.popupTimes < item.maxPopupTimes

      if (showing) {
        item.popupTimes++
        // item.updateDateSpan = new Date().getTime()
      }
      return ({
        ...item,
        showing: showing
      })
    }

    // 弹出限时充值福利弹窗
    if (itemIndex === 8 && currentModalIndex === 8) {
      let showing = true
      return ({
        ...item,
        showing: showing
      })
    }
    return item
  })

  localStorage.setItem('modals', JSON.stringify(modals))

  store.commit('setCurrentModalIndex', currentModalIndex)
  store.commit('setModals', modals)
}

/***
 * 关闭Modals数组中的show
 * 2023-03-27 hp
 */
export const closePop = function (index) {
  let modals = store.state.modals
  modals[index].showing = false
  store.commit('setModals', modals)
}

/****
 * User unique id from lcoal storage
 * @returns User unique id
 *
 * 2021-06-08 CHEN PU created function
 */
const getUserUniqueIdLocal = function () {
  var userInfoJSONStr = localStorage.getItem('userInfo')
  var userInfoJSON = null
  if (userInfoJSONStr) {
    userInfoJSON = JSON.parse(userInfoJSONStr)
  }
  return userInfoJSON == null ? null : userInfoJSON.UserId
}

/****
 * Get user visitor code
 * @returns user visitor code
 *
 * 2021-06-08 CHEN PU created function
 */
const getVisitorCode = () => {
  var visitorCode = localStorage.getItem('visitorCode')
  if (visitorCode == null) {
    visitorCode = generateUUID()
    localStorage.setItem('visitorCode', visitorCode)
  }
  return visitorCode
}

/****
 * Set user visitor code
 * @returns user visitor code
 *
 * 2021-06-08 CHEN PU created function
 */
const setVisitorCode = function (visitorCode) {
  if (visitorCode) {
    localStorage.setItem('visitorCode', visitorCode)
  }
}

/****
 * Create a unique id
 * @returns new unique id
 *
 * 2021-06-08 CHEN PU created function
 */
const generateUUID = () => {
  var d = new Date().getTime()
  if (window.performance && typeof window.performance.now === 'function') {
    d += performance.now() // use high-precision timer if available
  }
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0
    d = Math.floor(d / 16)
    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
  })
  return uuid
}

/*****
 * 在本地存储share code
 * @param inviteCode
 */
const setShareCode = function (shareCode) {
  localStorage.setItem('shareCode', shareCode)
}

/****
 * 检查是否存在新版本需要更新
 * @param localVersion
 * 2021-07-02 CHP Create
 * 2022-06-20 CHP 非核心业务走Service2
 */
const checkUpdate = function (localVersion) {
}

/****
 * 检查是否存在系统维护
 * @param localVersion
 * 2022-01-14 WXJ Create
 */
// const checkMaintenance = function () {
//   console.log('not check maintenance')
//   checkMaintenanceInterval()
//   setInterval(() => {
//   checkMaintenanceInterval()
//  }, 30000)
// }

// const checkMaintenanceInterval = function () {
//   let now = (new Date()).getTime()
//   try {
//     let testerTriggerTime = localStorage.getItem('testerTriggerTime')
//     if (testerTriggerTime == null || now - testerTriggerTime > 600000) {
//       localStorage.setItem('lastCheckMaintenance', now.toString())
//       const url = location.origin + '/static/maintenance.json'
//       axios.get(url, null, true).then(res => {
//         console.log(res.data)
//         if (res.data != null && res.data.state === 1) {
//           localStorage.setItem('maintenanceMessage', res.data.message)
//           store.commit('setMaintenanceState', true)
//           store.commit('setHideGiftPop', true)
//           store.commit('setHideVersionUpdatePop', true)
//           store.commit('setHidePromotionPop', true)
//           store.commit('setShowNoticePop', false)
//         } else {
//           store.commit('setMaintenanceState', false)
//         }
//       }).catch(err => {
//         console.log(err)
//       })
//     }
//   } catch (err) {
//     localStorage.setItem('lastCheckMaintenance', now.toString())
//   }
// }

/****
 * 检查用户是否满足召回条件
 * 2022-06-21 CHP 创建
 * 2022-11-11 HHY 去掉了对CallbackCashTimeSpan的判断
 */
const checkCallback = function () {
}

/***
 * Log Visit
 * 2022-06-21 CHP 从main.js移到这里
 */
const logVisit = function (location, to) {
}

/****
 * 添加下载APP操作记录(只用于home页面和landing页面的)
 * 2023-04-06 HP
 */
const downloadApp = function (position) {
  const url = '/innovation/log/logvisit'
  const visitorCode = getVisitorCode()
  const userUniqueId = getUserUniqueIdLocal()
  const data = {
    visitorCode: visitorCode,
    userUniqueId: userUniqueId,
    campaignId: localStorage.getItem('cid'),
    visitType: 'DownloadApp',
    pagePath: '',
    localVersion: config.version,
    apkVersion: localStorage.getItem('apkV') ? localStorage.getItem('apkV') : '1.0.0',
    internation: store.state.internation // 2022-03-13 CHP 增加
  }
  request2('post', url, data, true)
  const cid = localStorage.getItem('cid') || 'app'
  window.location.href = config.baseURL + 'mobileapp/pge-' + cid + '-' + config.apkVersion + '.apk'
}

export const afListener = (event) => {
  try {
    if (window.Android && localStorage.getItem('cid') && store.state.watchedCid.includes(localStorage.getItem('cid'))) { // 监听行为
      const jsonData = {
        event: event,
        userId: getUserUniqueIdLocal(),
        campaignId: localStorage.getItem('cid'),
        operatingTime: getDatetimeValues()
      }
      window.Android.callAppsflyer(JSON.stringify(jsonData))
      if (event.toLowerCase().indexOf('login') > -1 || event.toLowerCase().indexOf('register') > -1) {
        updateAFInfo(getUserUniqueIdLocal())
      }
    }
  } catch (err) {
    console.log(err)
  }
}

export const updateAFInfo = (userId) => { // 更新appsflyer Id
  const af = localStorage.getItem('af')
  if (af) {
    const afUrl = '/innovation/account/save/device'
    const afData = {
      UniqueId: userId,
      DeviceId: af
    }
    request('post', afUrl, afData).then(res => {
    }).catch((err) => {
      console.log(err)
    })
  }
}

export const getDatetimeValues = (type) => {
  const now = new Date()
  const year = now.getFullYear()
  const month = now.getMonth() + 1
  const day = now.getDate()
  const hour = now.getHours()
  const minute = now.getMinutes()
  const second = now.getSeconds()
  const currentTime = `${year}-${month >= 10 ? month : '0' + month}-${day >= 10 ? day : '0' + day} ${hour >= 10 ? hour : '0' + hour}:${minute >= 10 ? minute : '0' + minute}:${second >= 10 ? second : '0' + second}`
  return currentTime
}

/**
 * 增加存储过期时间
 * 2023-05-24 WXJ Created
 */
export const Storage = {
  setExpire: (key, value, second) => {
    key = 'storage:key:' + key
    if (isNaN(second) || second < 1) {
      throw new Error('second is valid')
    }
    let time = second * 1000
    let obj = {
      data: value,
      time: Date.now(),
      second: time
    }
    localStorage.setItem(key, JSON.stringify(obj))
  },
  getExpire: key => {
    key = 'storage:key:' + key
    let val = localStorage.getItem(key)
    if (!val) {
      return val
    }
    val = JSON.parse(val)
    if (Date.now() > val.time + val.second) {
      localStorage.removeItem(key)
      return null
    }
    return val.data
  }
}

/****
 * Log utils
 *
 * 2021-06-08 CHEN PU Add for log visit
 */
export const LogUtils = {
  getUserUniqueIdLocal: getUserUniqueIdLocal,
  getVisitorCode: getVisitorCode,
  setVisitorCode: setVisitorCode,
  generateUUID: generateUUID,
  setShareCode: setShareCode,
  checkUpdate: checkUpdate,
  // checkMaintenance: checkMaintenance,
  checkCallback: checkCallback,
  logVisit: logVisit,
  downloadApp: downloadApp
}



// WEBPACK FOOTER //
// ./src/utils.js